import { render, staticRenderFns } from "./IconDropdown.vue?vue&type=template&id=1a4e15e0"
import script from "./IconDropdown.vue?vue&type=script&lang=js"
export * from "./IconDropdown.vue?vue&type=script&lang=js"
import style0 from "./IconDropdown.vue?vue&type=style&index=0&id=1a4e15e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports